import {Component, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {DateTime, NavController, NavParams, TextInput, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, Util} from '../../../app/util';
import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {
    TAction,
    TPaymentFlag,
    TInvoiceFlag,
    TInvoiceMode,
    TPrecifyMenu,
    TProdutoView,
    TPaybookFlag,
    TPaybookTipo,
    TPaybookModo,
    TConsumoFlag,
    TConviteTipo,
    TAcessoFind,
    ENUM,
    TPrinterTipo,
    TLoginTipo,
    TDevicerScan,
} from "../../../app/enum";
import { Observable, Subscription } from 'rxjs/Rx';
import { PaybookRepo } from '../../../repositories/payment-repo';
import { ProdutoMenuPage } from "../produto-menu/produto-menu";
import { EntrakiOpenPage } from '../entraki-open/entraki-open';
import { ConsumoEditPage } from '../consumo-edit/consumo-edit';
import { ParcelaMenuPage } from '../parcela-menu/parcela-menu';
import { PaymentMenuPage } from '../payment-menu/payment-menu';
import { InvoiceMenuPage } from '../invoice-menu/invoice-menu';
import { MethodoMenuPage } from '../methodo-menu/methodo-menu';
import { LancakiMenuPage } from '../lancaki-menu/lancaki-menu';
import { ProfileAuthPage } from '../profile-auth/profile-auth';
import { MessageService } from '../../../providers/message-service';


@Component({
    selector: 'page-paybook-menu',
    templateUrl: 'paybook-menu.html',
    providers: [ProfileService, HotspotService, PaybookRepo]
})
export class PaybookMenuPage {

    public subscription: Subscription;
    
    TPaymentFlag: any = TPaymentFlag;
    TInvoiceFlag: any = TInvoiceFlag;
    TInvoiceMode: any = TInvoiceMode;
    TConsumoFlag: any = TConsumoFlag;

    enum: any = ENUM;
    config: any;
    logado: any;

    profile: any;
    branded: any;
    userset: any;
    paybook: any;
    olhaapp: boolean;

    etapa: number;
    workday: boolean;
    fronter: false | true | 'noro';

    hotspotID: number;
    monitorBool: boolean;
    requestIpad: boolean;
    paybookAuth: boolean;

    //Many Comandas
    rootComanda: any;
    comandaIN: number = 0;
    
    comandaText: string = '';
    comandaPlus: boolean;

    hardwareNfc = (window as any).handappMainInstance.escutarBool && window.innerHeight >= 700;

    @ViewChild('inputCheckin') inputCheckin: TextInput;
    @ViewChildren(DateTime) iondates: QueryList<DateTime>;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public hotspotService: HotspotService,
                public viewCtrl: ViewController, public util: Util,
                public logadoService: LogadoService,
                public messageService: MessageService,
                public paybookRepo: PaybookRepo) {


        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.workday = this.navParams.get('workday');
        this.fronter = this.navParams.get('fronter');
        this.profile = this.navParams.get('profile');
        this.branded = this.navParams.get('branded');
        this.userset = this.navParams.get('userset');
        this.paybook = this.navParams.get('paybook');
        this.olhaapp = this.navParams.get('olhaapp');

        this.hotspotID = this.navParams.get('hotspotID');
        let paybookID = this.navParams.get('paybookID');

        this.monitorBool = this.navParams.get('monitorBool');
        this.requestIpad = this.navParams.get('requestIpad'); //#IPAD-BARMAN-CHECKIN


        //#GAMB - ARRUMAR - DEVELOP MANY COMANDAS
        let comandas = (this.paybook ? [this.paybook] : []);
        this.rootComanda = {Comandas: comandas};

        this.escutarNear();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Paybook Menu', '/paybook-menu');

        if (this.etapa == 0 && paybookID) this.paybookLoad(paybookID);

    }




    /** ************************************************ PAYBOOK ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    getTitle() {

        if (this.etapa == 0) return (this.paybook ? (this.paybook.Projeto ? this.paybook.Projeto.ProjetoNome : '') : (!this.profile ? 'Consumidor' : this.profile.ProfileShow));

    }

    onlyLoged(): Observable<void> {

        return new Observable(observer => {

            let onResult = () => {

                //#IPAD-BARMAN - Fez login com outro usuario, fecha a tela barman para pedir pin novamente!
                this.paybookAuth = true;
                    
                this.logado = this.logadoService.getAuth();
                if (!this.logado) {
                    observer.complete();
                    return;
                }

                observer.next();
                observer.complete();

            };

            let object = {etapa: 0, rootile: null, loginTipo: TLoginTipo.loPassword, justLogin: true, requestIpad: this.requestIpad};
            if (!this.paybookAuth) this.util.modalopen(ProfileAuthPage, 'alto', false, object).subscribe(() => onResult());
            if ( this.paybookAuth) onResult();

        });

    }


    pagapayFlag() {

        if (!this.workday && this.logado && this.logado.Profile.ProfileID == this.paybook.Profile.ProfileID) return 'eye';
        return (this.userset && !this.requestIpad && this.userset.UsuarioCaxa) || (!this.workday && this.paybookDebt() > 0);
      //return (this.userset && !this.requestIpad                            ) || (!this.workday && this.paybookDebt() > 0);

    }

    paybookTint() {

        if (this.etapa == 0) return (this.branded ? this.branded.BrandedCora : 'CorRoxa');
        if (this.etapa == 4) return 'CorMenu';
        if (this.etapa == 5) return 'CorRoxa';
        if (this.etapa == 6) return 'CorRoxa';

    }

    paybookLoad(paybookID, comandaText?, forcadoText?) {

        if (!paybookID && !forcadoText && !this.util.validaCNPF(comandaText)) return;

        //DESK
        if (!this.olhaapp) {
            let onLoad = (data) => {
                this.comandaText = '';

                if (this.logado) {
                    if (!this.userset) this.userset = {};
                    this.util.populateObj(this.userset, data.Usuarios[0]);
                }


                //if (!this.paybook) this.paybook = data.Comandas[0];
                //else this.util.clearObj(this.paybook, [], data.Comandas[0]);

                let array = this.rootComanda.Comandas;
                let comanda = (data.Comandas || [])[0];
    
                if (!comanda) {
                    this.util.alertSimply('Não encontrado');
                    return;
                }
    
                if (comanda && array[0] && comanda.PaybookPrey != array[0].PaybookPrey) {
                    this.util.alertSimply('Pós vs Pré');
                    return;
                }
    
                if (comanda) {
                    let index = array.findIndex(CO => CO.ComandaID == comanda.ComandaID);
                    if (index < 0) {
                        array.push({});
                        index = array.length-1;
                    }
                    this.util.populateObj(array[index], comanda);
                    this.paybook = array[index];

                    if (array.length > 1) this.comandaPlus = true;
                }
    
            };

            let rnrn = this.util.validaCNPF(comandaText);
            let params = '&ComandaText=' + (paybookID ? paybookID : comandaText) +
                         '&ComandaMode=' + (paybookID ? TAcessoFind.afFindID : (rnrn ? TAcessoFind.afFindRnid : TAcessoFind.afFindNoro)) +
                         '&DetalheBool=' + false;
    
            this.monitorDesk('DESK-Comanda', TAction.acInfo, params, null, onLoad);
            return;
        }

        //SYNC - Bridging...
        if (!this.olhaapp) {
            this.hotspotService.paybook(TAction.acBook, paybookID)
                .subscribe(
                    data => {
                        if (!data.Paybooks || !data.Paybooks[0]) {
                            this.util.toastSimply('Paybook não encontrado', 3000, () => this.dismiss());
                            return;
                        }

                        data.Paybooks[0].PaybookDate = data.Paybooks[0].PaybookCria.split(' ')[0];
                        this.paybook = data.Paybooks[0];
                    },
                    erro => this.util.alertResult(erro, () => this.dismiss())
                );
        }

    }

    paybookEdit(action: TAction = TAction.acEdit, that: any = null) {

        let onDone = () => {
            if (that) that.dismiss();
        };

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.paybook(action, this.paybook.PaybookID, 0, 0, 0, '', this.paybook)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onDone(),
                erro => this.util.alertResult(erro)
            );

    }

    paybookNoro(paybookNoro) {

        if (!paybookNoro || this.paybook.PaybookNoro == paybookNoro) {
            this.fronter = false;
            return;
        }



        //this.paybook.PaybookNoro = paybookNoro;
        //this.paybookEdit(TAction.acNoro, that);



        let onSave = () => {
            this.fronter = false;
            this.paybook.PaybookNoro = paybookNoro;
            this.dismiss(); //#G - Force close PaybookMenu finalizou tudo "AGILIDADE"!
        };

        let params = '&ComandaID=' + this.paybook.ComandaID + '&ComandaNoro=' + paybookNoro;
        this.monitorDesk('DESK-Comanda', TAction.acNoro, params, null, onSave);

    }

    monitorDesk(document, action, params, json, onSave) {

        let hotspotID = (this.hotspotID ? this.hotspotID : (this.paybook ? this.paybook.HotspotID : 0));

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(this.monitorBool, document, hotspotID, params, action, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onSave(data),
                erro => this.util.alertResult(erro));

    }

    paybookDoor() {

        let lino = this.paybook.Profile;
        let hotspot = this.paybook;

        let object = {etapa: 1, monitorBool: this.monitorBool, hotspot: hotspot, userset: this.userset, profileDesk: lino, spotdayID: 0, paybookTipo: TPaybookTipo.pbCard, paybookModo: TPaybookModo.pmUser, conviteTipo: TConviteTipo.ctConvitePorta, comandaID: this.paybook.ComandaID};
        this.util.modalopen(EntrakiOpenPage, 'quad', true, object)
            .subscribe(done => {

                //EXCLUIR - Comentei, precisa disso?
                //this.paybook.Ambient = done.Voucher.Ambient;

                this.paybookLoad(this.paybook.ComandaID)

            });

    }

    paybookGorj() {

        let onOkay = () => {
            let onSave = () => this.paybook.Consumos.forEach(CS => CS.Consumo.ConsumoMore = 0);
            let params = '&ComandaID=' + this.paybook.ComandaID + '&GorjetaCash=' + 0;
            this.monitorDesk('DESK-Comanda', TAction.acMore, params, null, onSave);
        }

        let alerta = 'Esse processo não tem volta.';
        this.util.alertQuestion('Deseja remover a gorjeta?', alerta, 'Continuar', () => onOkay(), false, true);

    }

    paybookTeto() {

        let onDone = (root, ruut) => {

            let onSave = () => {
                this.paybook.PaybookTeto = root;
                this.dismiss(); //#G - Force close PaybookMenu finalizou tudo "AGILIDADE"!
            }

            let params = '&ComandaID=' + this.paybook.ComandaID + '&ComandaTeto=' + root;
            this.monitorDesk('DESK-Comanda', TAction.acTeto, params, null, onSave);

        };


        /** OPEN **/
        let columns = [];

        let buttons: Array<any> = [];
        
        let paybookLoop = this.paybook.PaybookTeto;
                         buttons.push({text: this.util.dinheiro(0, false), value: 0});
        if (paybookLoop) buttons.push({text: this.util.dinheiro(paybookLoop, false), value: paybookLoop});

        for (let i = 0; i <= 30; i = i + 1) {
            paybookLoop += (paybookLoop < 1000 ? 50 : 100);
            buttons.push({text: this.util.dinheiro(paybookLoop, false), value: paybookLoop});
        }
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = 0;

        this.util.pickerOpen(columns, onDone);

    }

    paybookLock() {

        let lock = ([TPaybookFlag.pfWalk, TPaybookFlag.pfBill, TPaybookFlag.pfLock].indexOf(this.paybook.PaybookFlag) >= 0 ? TPaybookFlag.pfOpen : TPaybookFlag.pfLock);

        let onSave = () => {
            this.paybook.PaybookFlag = lock;
            this.dismiss(); //#G - Force close PaybookMenu finalizou tudo "AGILIDADE"!
        }

        let params = '&ComandaID=' + this.paybook.ComandaID + '&ComandaFlag=' + lock;
        this.monitorDesk('DESK-Comanda', TAction.acLock, params, null, onSave);

    }

    paybookDate() {

        let date = this.paybook.PaybookDate;
        let hora = this.paybook.PaybookCria.split(' ')[1];
        this.paybook.PaybookCria = date + ' ' + hora;
        this.paybookEdit(TAction.acEdit);

    }

    paybookSave() {

        console.log(this.paybook.PaybookCria);

    }

    paybookOpen(paybook) {

        if (this.rootComanda.Comandas.length == 1) {
            this.comandaPlus = false;
            return;
        }

        this.comandaPlus = false;
        this.paybook = paybook;

        // let profile = paybook.Profile;
        // let branded = paybook.Branded;
        // let hotspotID = paybook.HotspotID;
        // let object = {etapa: 0, olhaapp: false, monitorBool: this.monitorBool, fronter: false, profile: profile, branded: branded, userset: this.userset, paybookID: 0, paybook: paybook, hotspotID: hotspotID};
        // this.util.modalopen(PaybookMenuPage, 'alto', false, object).subscribe();

    }

    paybookGear() {

        //checkinSelf
        if (!this.userset) return;


        let onDone = () => {

            /** ADMINISTRATIVO **/
            /** -------------------------------------------------------------------------------------------------------- **/
            let onCria = () => {
                setTimeout(() => this.iondates.toArray()[0].open(), 200);
            };

            let onVenc = () => {
                let object = {etapa: 2, olhaapp: this.olhaapp, userset: this.userset, paybook: this.paybook};
                this.util.modalopen(ParcelaMenuPage, 'alto', false, object).subscribe();
            };

            let onLixo = () => {

            };



            /** OPERACIONAL **/
            /** -------------------------------------------------------------------------------------------------------- **/
            // let onMoto = () => {

            //     let onMode = (tipo) => {
            //         this.paybook.PaybookTipo = tipo;
            //         this.paybookEdit(TAction.acEdit, null);
            //     };

            //     /** OPEN **/
            //     let buttons: Array<any> = [];
            //     buttons.push({text: 'Entrega', handler: () => onMode(TPaybookTipo.pbSend)});
            //     buttons.push({text: 'Retirar', handler: () => onMode(TPaybookTipo.pbTake)});
            //     this.util.sheetOpen(buttons, 'PAGAMENTO');

            // };
            
            let onDoor = () => {
                this.paybookDoor();
            };

            let onGorj = () => {
                this.paybookGorj();    
            };

            let onNoro = () => {
                this.fronter = 'noro';
            };

            let onTeto = () => {
                this.paybookTeto();
            };

            let onItem = () => {
                this.consumoEdit(null);
            };

            let onLock = () => {
                this.paybookLock();
            };



            /** OPEN **/
            let user = (this.userset ? this.userset.UsuarioCaxa : false);
            let tipo = (this.paybook.PaybookTipo >= TPaybookTipo.pbCard && !this.paybook.PaybookBora);
        // let moto = (this.paybook.PaybookTipo == TPaybookTipo.pbSend || this.paybook.PaybookTipo == TPaybookTipo.pbTake);
            let bool = (user && !tipo);

            let buttons: Array<any> = [];

            if (this.paybook.PaybookTipo == TPaybookTipo.pbCron) {
                if (bool) buttons.push({text: 'Competência',  handler: () => onCria()});
                if (user) buttons.push({text: 'Parcelamento', handler: () => onVenc()});
                        buttons.push({text: 'Excluir',      handler: () => onLixo(), role: 'destructive'});
            }
            else {
                let lock = ([TPaybookFlag.pfWalk, TPaybookFlag.pfBill, TPaybookFlag.pfLock].indexOf(this.paybook.PaybookFlag) >= 0)
                let travar = (lock ? 'Destravar' : 'Travar');
                /*if (this.userset.UsuarioMaxi)*/ buttons.push({text: 'Consumo',      handler: () => onItem()});
                //if (moto)                       buttons.push({text: 'Entrega',      handler: () => onMoto()});
                /*if (this.userset.UsuarioDoor)*/ buttons.push({text: 'Portaria',     handler: () => onDoor()});
                /*if (this.userset.UsuarioGorj)*/ buttons.push({text: 'Gorjeta',      handler: () => onGorj()});
                /*if (this.userset.UsuarioGoid)*/ buttons.push({text: 'Número',       handler: () => onNoro()});
                /*if (this.userset.UsuarioMaxi)*/ buttons.push({text: 'Limite',       handler: () => onTeto()});
                                                  buttons.push({text: travar,         handler: () => onLock(), role: 'destructive'});
            }
            this.util.sheetOpen(buttons, 'PAYBOOK', 0);

        }

        if (!this.requestIpad) onDone();
        if ( this.requestIpad) this.onlyLoged().subscribe(() => onDone());
        //# ESSE LOGIN FOI FEITO COM PINUMBER ENTÃO PRECISA PEDIR A SENHA PARA GARANTIR!

    }

    comandaPluz() {

        this.comandaPlus = true;
        setTimeout(() => {
            if (this.inputCheckin) this.inputCheckin.setFocus();
        }, 0);

    }

    paybookDebt(): number {

        let parcelas = (this.paybook.Parcelas || []);
        let qtde = parcelas.length;
        if (qtde)  return this.parcelaDebt(null);
        if (!qtde) return this.paybookRepo.consumoDebt(this.paybook, null);

    }

    paybookCash(): number {

        let result = 0;
        this.rootComanda.Comandas.forEach(PB => result = result + ENUM.paybookCash(PB, 'Deve'));
        return result;

    }




    /** ************************************************ MONITOR ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    bmaskerMask() {

        let size = (this.comandaText || '').replace('.', '').length;
        let mask = (size <= 4 ? '0000' : (size == 5 ? '00.000' : '000.000.000-00'));
        return {mask: mask, type: 'num', len: mask.length};

    }

    comandaExit() {

        let hotspotID = this.paybook.HotspotID;

        let onExit = (root) => {
            this.rootComanda.Comandas[this.comandaIN].Outbook = root.Comandas[0].Outbook;
            this.util.impact();

            let onThen = () => {};//this.navCtrl.getPrevious().dismiss();
            let paybook = this.rootComanda.Comandas[this.comandaIN];
            let object = {etapa: 3, paybook: paybook};
            this.util.modalopen(EntrakiOpenPage, 'alto', false, object, null, null, null, onThen).subscribe();
        };

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ComandaID=' + this.rootComanda.Comandas[this.comandaIN].ComandaID;
        this.util.monitorDesk(this.monitorBool, 'DESK-Comanda', hotspotID, params, TAction.acExit)
            .finally(() => loading.dismiss())
            .subscribe(
                root => onExit(root),
                erro => this.util.alertResult(erro));

    }

    paybookTira(paybook) {

        let index = this.rootComanda.Comandas.indexOf(paybook);
        this.rootComanda.Comandas.splice(index, 1);

    }

    comandaMenu(comanda) {

        let index = this.rootComanda.Comandas.indexOf(comanda);

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Abrir',      handler: () => this.paybookOpen(comanda)});
        buttons.push({text: 'Vender',     handler: () => this.lancakiMenu(comanda)});
        if (index > 0)
        buttons.push({text: 'Remover',    handler: () => this.paybookTira(comanda), role: 'destructive'});
        this.util.sheetOpen(buttons, 'ACTION', 0);

    }

    controlSize(call: 'Pagaki' | 'Lançaki' | 'Imprimeaki' | 'Checkout'): string {

        let locksai  = (this.paybook.PaybookBora || this.paybook.PaybookFlag > TPaybookFlag.pfOpen);
        let pagaki   = (this.userset && this.userset.UsuarioCaxa && this.comandaPlus);
        let lancaki  = (this.userset && this.userset.UsuarioSale && !this.comandaPlus && !this.requestIpad && !locksai);
        let checkout = (this.userset && this.userset.UsuarioSair && !this.comandaPlus && this.paybook.SettingSair);

        if (call == 'Pagaki')     return (pagaki ? '135px' : null);
        if (call == 'Lançaki')    return (lancaki && checkout ? '110px' : (lancaki && !checkout ? '135px' : null));    //Sempre que tem venda pode imprimir
        if (call == 'Checkout')   return (lancaki && checkout ? '110px' : (!lancaki && checkout ? '135px' : null));
        if (call == 'Imprimeaki') return (lancaki && checkout && !pagaki ? '110px' : (pagaki || lancaki || checkout ? '135px' : '270px'));

    }

    //PRINTER
    printerLoad() {

        //GAMBI - Corrigindo o Click do Usuario
        if (this.comandaText) {
            this.paybookLoad(0, this.comandaText, true);
            this.comandaText = '';
            return;
        }

        let onLoad = (data) => {
            /** OPEN **/
            let buttons: Array<any> = [];
            let array = data.Printers.filter(PR => PR.PrinterTipo == TPrinterTipo.ptPrinterTodos || PR.PrinterTipo == TPrinterTipo.ptPrinterBill);
            array.forEach(PR => buttons.push({text: PR.PrinterNome,  handler: () => this.printerBill(PR.PrinterID)}));
            this.util.sheetOpen(buttons, 'PRINTER', 0);
        };

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(this.monitorBool, 'DESK-Printer', this.paybook.HotspotID, '', TAction.acLoad)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onLoad(data),
                erro => this.util.alertResult(erro, () => this.comandaText = ''));

    }

    //PRINTER
    printerBill(printerID) {

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&PrinterID=' + printerID + '&ComandaID=' + this.util.jsCat(this.rootComanda.Comandas, ['ComandaID']);
        this.util.monitorDesk(this.monitorBool, 'DESK-Printer', this.paybook.HotspotID, params, TAction.acBill)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.util.toastSimply('Míssil de conta enviado!', 3000),  //, () => this.dismiss()),
                erro => this.util.alertResult(erro, () => this.comandaText = ''));

    }



    /** ************************************************ CONSUMO ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    //CONSUMO
    lancakiMenu(comanda?) {

        //DESK
        let onDesk = () => {
            if (!comanda) comanda = this.rootComanda.Comandas[0];

            let onThen = () => {};//this.navCtrl.getPrevious().dismiss();
            let object = {etapa: 5, monitorBool: this.monitorBool, requestIpad: false, hotspotID: this.paybook.HotspotID, rootComanda: this.rootComanda, comandaIN: 0, clusterIN: -1};
            this.util.modalopen(LancakiMenuPage, 'alto', false, object, null, null, null, onThen)
                .finally(() => {
                    //this.rootComanda.Comandas[this.comandaIN].Mesa = null;
                    //this.rootComanda.Comandas[this.comandaIN].Seat = null;
                })
                .subscribe();    
        }

        //SYNC
        let onSync = () => {
            //let object = {etapa: 0, homeb: false, rootspot: null, produtoFull: false, produtoView: TProdutoView.pdLancar, precifyMenu: TPrecifyMenu.pcNormal};
            //this.navCtrl.push(ProdutoMenuPage, object);
    
            //Pedido - Consumo
            let object = {etapa: 1, homeb: false, clusters: null, indexes: null, rootspot: {Hotspots: [{HotspotID: 1010}]}, themedep: null, produtoFull: false, produtoView: TProdutoView.pdLancar, precifyMenu: TPrecifyMenu.pcNormal};
            this.util.modalopen(ProdutoMenuPage, 'alto', false, object).subscribe(
                data => {

                    if (data && data.blended) {
                        console.log(data.blended);
                        let consumo = {ConsumoID: 0, ConsumoFlag: TConsumoFlag.cfLancado, ConsumoPack: 0, ConsumoQtde: 1, ConsumoCash: 1, ConsumoLess: 0, Justify: null, Profile: null, Usuario: null, Blended: data.Blended, Imposto: null};
                        this.paybook.Consumos.push(consumo);
                    }

                });
        }

        //DESK
        if (!this.olhaapp) onDesk();
        if ( this.olhaapp) onSync();

    }
    
    consumoEdit(index) {

        //checkinSelf
        if (!this.userset) return;


        //Consumo/Edit/List
        if (index == null) {
            let object = {etapa: 0, olhaapp: this.olhaapp, userset: this.userset, paybook: this.paybook, indexCS: index, monitorBool: this.monitorBool};
            this.util.modalopen(ConsumoEditPage, 'alto', false, object).subscribe();    
            return;
        }

        
        //#GAMB - ProdutoTipo.ptConvite - DESK
        if (this.paybook.Consumos[index].Produto.ProdutoTipo == 8) {
            this.util.toastSimply('Altere a Portaria em "..."');
            return;
        }

        let object = {etapa: 1, olhaapp: this.olhaapp, userset: this.userset, paybook: this.paybook, indexCS: index, monitorBool: this.monitorBool};
        this.util.modalopen(ConsumoEditPage, 'alto', false, object).subscribe();

    }




    /** ************************************************ PARCELA ************************************************** **/
    /** ************************************************ setuper ************************************************** **/


    parcelaFlug(index, flug: 'paint' | 'tint' | 'note') {

        if (flug == 'paint') {
            if (this.parcelaDebt(index, true) > 0) return 'CorVerm';
            return 'CorGelo';
        }

        if (flug == 'tint') {
            if (this.parcelaDebt(index, true) > 0) return 'CorVerm';
            if (this.parcelaDebt(index, false) == 0) return 'CorLime';
            return 'CorText';
        }

        if (flug == 'note') {
            let debt = this.parcelaDebt(index, false);
            return (debt == 0 ? 'Quitado' : this.util.dinheiro(debt));
        }

    }

    parcelaDebt(index, vencido?): number {

        return this.paybookRepo.parcelaDebt(this.paybook, index, vencido);

    }

    parcelaLock(index): boolean {

        if (index > 0 && this.paybook.Parcelas[index].Payjoins.length == 0 && this.parcelaDebt(index-1) > 0) {
            this.util.alertSimply('Existe parcela anterior aberta!<br>Quite o débito em ordem.', 'Pagamento');
            return true;
        }

        return false;

    }

    parcelaOpen(index) {

        let onPago = () => {
            if (this.parcelaLock(index)) return;

            let object = {etapa: 3, olhaapp: this.olhaapp, userset: this.userset, paybook: this.paybook, indexPL: index};
            this.util.modalopen(ParcelaMenuPage, 'alto', false, object).subscribe();
        };

        let onDate = () => {
            setTimeout(() => this.iondates.toArray()[index+1].open(), 200);
        };



        /** OPEN **/
        let debt = this.parcelaDebt(index);
        let buttons: Array<any> = [];
                  buttons.push({text: 'Pagamento',  handler: () => onPago()});
        if (debt) buttons.push({text: 'Vencimento', handler: () => onDate()});
        if (debt) buttons.push({text: 'Data Ágio',  handler: () => this.paybookRepo.parcelaAgio(this.paybook, index)});
        this.util.sheetOpen(buttons, (index+1) + 'º PARCELA');

    }



    /** ************************************************ PAYMENT ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    methodoMenu() {

        if (this.requestIpad) {
            return;
        }

        if (this.userset && !this.userset.UsuarioCaxa) {
            this.util.toastSimply('Acesso Negado "RECEBER"');
            return;
        }

        //if (!this.userset || (this.userset && !this.userset.UsuarioCaxa)) {
        if (!this.userset) {
            this.rootComanda.Comandas[0].PaybookHide = !this.rootComanda.Comandas[0].PaybookHide;
            return;
        }

        if (this.rootComanda.Comandas.length > 1 && this.paybookCash() <= 0) {
            this.util.toastSimply('Nenhum valor a pagar');
            return;
        }
        
        //Comanda - Fecha a janela
        let onThen = () => {};//this.navCtrl.getPrevious().dismiss();
        let object = {etapa: 0, monitorBool: this.monitorBool, hotspotID: 0, userset: this.userset, rootComanda: this.rootComanda};
        this.util.modalopen(MethodoMenuPage, 'alto', false, object, null, null, null, onThen).subscribe(
            json => {
                if (!json._finishTela) this.rootComanda.Comandas.forEach(CO => this.paybookLoad(CO.ComandaID));
                if ( json._finishTela && json.ComandaDoze) this.invoiceEmit();
            });

    }

    paymentLink(indexPL, indexPJ, press) {

        if (press) this.paybook.Parcelas[indexPL].Payjoins[indexPJ].Plastic = null;

        let object = {etapa: 4, olhaapp: this.olhaapp, userset: this.userset, paybook: this.paybook, indexPL: indexPL, indexPJ: indexPJ};
        this.util.modalopen(PaymentMenuPage, 'alto', false, object).subscribe();

    }



    /** ************************************************ INVOICE ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    invoiceEmit() {

        let onThen = () => {};//this.navCtrl.getPrevious().dismiss();

        let object = {etapa: 0, flagstor: false, userset: this.userset, paybook: null, indexPN: 0, comandaList: this.rootComanda.Comandas};
        this.util.modalopen(InvoiceMenuPage, 'alto', false, object, null, null, null, onThen).subscribe();

    }

    invoiceOpen(index) {

        let object = {etapa: 1, flagstor: false, userset: this.userset, paybook: this.paybook, indexPN: index};
        this.util.modalopen(InvoiceMenuPage, 'alto', false, object).subscribe();

    }

    escutaScan() {

        (window as any).handappMainInstance.escutarScan();

    }

    escutarNear() {

        this.subscription =
        this.messageService.get(TDevicerScan[TDevicerScan.dsComanda]).subscribe(
            data => {

                // TELA-DISPONIVEL - Entraki não faz nada | Tela nao esta pedindo comanda!
                // let hardwareNfc = (this.comandaPlus || this.fronter == 'noro');
                // if (!hardwareNfc) return;

                //console.log(json);
                let json = this.util.jsParse(data);
                if (!json) {
                    this.util.alertSimply(data, 'JSON ERROR');
                    return;
                }

                //comandaScan - Enter
                if (json.ComandaNoro && this.fronter != 'noro') {
                    this.paybookLoad(0, json.ComandaNoro+'', true);    
                }

                //comandaScan - Enter (alterar numero comanda)
                if (json.ComandaNoro && this.fronter == 'noro') {
                    this.paybookNoro(json.ComandaNoro);
                }

            }
        );

        (window as any).handappMainInstance.escutarTela(TDevicerScan.dsComanda);

    }



    dismiss() {

        if (!this.comandaPlus && this.rootComanda.Comandas.length > 1) {
            this.comandaPluz();
            return;
        }


        //Checkin pelo usuario volta escutar Workday!
        let escutarTela = (this.util.websterOpen ? TDevicerScan.dsWorkday : TDevicerScan.dsEntraki);
        (window as any).handappMainInstance.escutarTela(escutarTela);
        
        //Unregister Escutar
        this.subscription.unsubscribe();


        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss({paybookAuth: this.paybookAuth}, 'back');
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/paybook-menu/paybook-menu.ts